import { Outlet, useLocation } from 'react-router-dom';
import Header from '../common/Header';
import Footer from '../common/Footer';
import ImpersonationBanner from '../common/ImpersonationBanner';

export default function MainLayout() {
  const location = useLocation();
  const isGamePage = location.pathname.startsWith('/juegos/') && location.pathname !== '/juegos';

  if (isGamePage) {
    return (
      <div className="h-viewport overflow-hidden flex flex-col">
        <ImpersonationBanner />
        <Header />
        <main className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <ImpersonationBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
